import { RegisteredComponent } from "@builder.io/sdk-react";

export const lottieBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Lottie",
  image:
    "https://cdn.iconscout.com/icon/free/png-512/free-lottiefiles-logo-icon-svg-download-png-4674917.png?f=webp&w=256",
  inputs: [
    {
      name: "src",
      type: "AprimoAssetSelector",
      options: {
        searchingExpression:
          'Contentstatus = "Released" AND File.Version.Extension = "json" AND Classification.NamePath = "/DAM/Audience/External" AND Classification.NamePath = "/DAM/Status/Available"',
      },
      required: true,
      localized: false,
      helperText:
        "Select the lottie file from the DAM (Aprimo). Only lottie files which are permitted to use on the website are selectable; therefore, archived, draft or internal assets can't be selected.",
    },
    {
      name: "autoplay",
      type: "boolean",
      localized: false,
    },
    {
      name: "loop",
      type: "boolean",
      localized: false,
    },
    {
      name: "backgroundColor",
      type: "color",
      localized: false,
    },
    {
      name: "layout",
      type: "object",
      localized: false,
      subFields: [
        { name: "alignX", type: "number", defaultValue: 0.5 },
        { name: "alignY", type: "number", defaultValue: 0.5 },
        {
          name: "fit",
          type: "enum",
          defaultValue: "contain",
          enum: ["fill", "contain", "cover", "none", "fit-width", "fit-height"],
        },
      ],
    },
  ],
};
